import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";
import { GHL_CALENDAR_URL, externalLinkProps } from "../../config/ghl";

export const CTASection = () => {
  const { t, lp } = useI18n();
  return (
    <section className="py-12 lg:py-20" data-testid="cta-section">
      <div className="max-w-5xl mx-auto px-6">
        <div className="relative glass-strong rounded-3xl p-10 sm:p-14 overflow-hidden">
          <div className="absolute inset-0 -z-10 grid-pattern opacity-30" />
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-blue-600/20 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-cyan-500/15 blur-3xl" />

          <div className="relative text-center">
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight max-w-3xl mx-auto leading-tight">
              {t.cta.title}
            </h2>
            <p className="text-slate-300 mt-5 text-lg max-w-2xl mx-auto">{t.cta.sub}</p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <a
                href={GHL_CALENDAR_URL}
                {...externalLinkProps}
                data-testid="cta-book-demo-btn"
                className="btn-cta inline-flex items-center gap-2 font-semibold px-7 py-4 rounded-xl"
              >
                {t.cta.btn} <ArrowRight size={18} />
              </a>
              <Link
                to={lp("/contact")}
                data-testid="cta-contact-btn"
                className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/15 hover:border-white/30 text-white font-medium px-7 py-4 rounded-xl"
              >
                <Mail size={16} /> {t.cta.btn2}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
